import { render, staticRenderFns } from "./LightState.vue?vue&type=template&id=048b5e38&scoped=true&"
import script from "./LightState.vue?vue&type=script&lang=js&"
export * from "./LightState.vue?vue&type=script&lang=js&"
import style0 from "./LightState.vue?vue&type=style&index=0&id=048b5e38&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "048b5e38",
  null
  
)

export default component.exports